import { loadGameHistory } from "./load_game_history"
import { saveGameHistory } from "./save_game_history"

export namespace Persistence {
  export const saveHistory = saveGameHistory
  export const loadHistory = loadGameHistory
}
